import { render, staticRenderFns } from "./BaseLuckdraw.vue?vue&type=template&id=284c092c&scoped=true&"
import script from "./BaseLuckdraw.vue?vue&type=script&lang=js&"
export * from "./BaseLuckdraw.vue?vue&type=script&lang=js&"
import style0 from "./BaseLuckdraw.vue?vue&type=style&index=0&id=284c092c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284c092c",
  null
  
)

export default component.exports